import { z } from 'zod';

import { MESSAGE } from '@/lib/constants';

export const addEmployeeSchema = z.object({
  fullName: z.string().trim().min(1, { message: MESSAGE.REQUIRED_FIELD }),
  email: z
    .string()
    .trim()
    .email({ message: 'Enter a valid email address' })
    .optional()
    .or(z.literal('')),
  phone: z.string().trim().optional(),
  title: z.string().trim().optional(),
  hiredAt: z.string().optional(),
});

export type AddEmployeeInput = z.infer<typeof addEmployeeSchema>;

export const editEmployeeSchema = z.object({
  title: z.string().trim().optional(),
  status: z.enum(['active', 'inactive']),
  hiredAt: z.string().optional(),
});

export type EditEmployeeInput = z.infer<typeof editEmployeeSchema>;
